import { useId } from 'react';
import { View } from 'react-native';
import clsx from 'clsx';
import { Image } from 'shared/components/image';
import colors from 'shared/library/colors';
import { EVIDENSIA_LOGO_URL, type EvidensiaLogoProps } from './evidensia-logo.shared';

export function EvidensiaLogo({ align = 'left', size = 'default' }: EvidensiaLogoProps) {
  const filterId = `evidensia-logo-${useId().replace(/:/g, '')}`;
  return (
    <View className={'items-start'}>
      <svg width={0} height={0} aria-hidden style={{ position: 'absolute' }}>
        <defs>
          <filter id={filterId} colorInterpolationFilters="sRGB">
            <feFlood floodColor={colors.brand.evidensia} />
            <feComposite in2="SourceAlpha" operator="in" />
          </filter>
        </defs>
      </svg>
      <View style={{ filter: `url(#${filterId})` }}>
        <Image
          src={EVIDENSIA_LOGO_URL}
          alt={'Evidensia Djursjukvård'}
          width={size === 'small' ? 80 : size === 'compact' ? 96 : 128}
          containerClassName={clsx(
            'relative shrink-0',
            size === 'small'
              ? 'h-8 w-20'
              : size === 'compact'
                ? 'h-10 w-24'
                : 'h-10 w-24 md:h-14 md:w-32',
          )}
          imageClassName={
            align === 'right' ? 'object-contain object-right' : 'object-contain object-left'
          }
        />
      </View>
    </View>
  );
}
